import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Nosotros from '../views/Nosotros'
import HowToDelete from '../views/HowtoDelete'
import Info from '../views/Info'
import AppKefuri from '../views/App-kefuri'
import Contactanos from '../views/Contactanos'
import politicaPrivacidad from '../views/Politica-privacidad'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/Nosotros',
    name: 'Nosotros',
    component: Nosotros
  },
  {
    path: '/Info',
    name: 'Info',
    component: Info
  },
  {
    path: '/App-kefuri',
    name: 'App-kefuri',
    component: AppKefuri
  },
  {
    path: '/Contactanos',
    name: 'Contactanos',
    component: Contactanos
  },
  {
    path: '/Politica-privacidad',
    name: 'Politica-privacidad',
    component: politicaPrivacidad
  },
  {
    path: '/HowToDelete',
    name: 'HowToDelete',
    component: HowToDelete
  },
  {
    path: '*',
    redirect: '/',
    component: Home
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
